module.exports = __webpack_public_path__ + "img/SefLinkPlusLogo.7a7b5a00.svg";